(() => {
  const mobilePreviewNoShrink = () => {
    const builder = document.querySelector('#product-builder');
    const previewSticky = document.querySelector('.cpb-preview-sticky');
    const previewLayers = document.querySelector('.cpb-preview-layers');
    const previeElements = document.querySelector('.cpb-preview-elements');

    const update = () => {
      setTimeout(() => {
        const unshrinkedHeight = previewSticky.getAttribute('style').match(/height:.+px;/img)[0].split(' ')[1].replace(';', '');
        builder.style.setProperty('--unshrinked-height', `${unshrinkedHeight}`);
      }, 100);
    }

    builder.dataset.unshrinkedHeight = true;
    
    update();
    document.body.addEventListener('CPB_ON_RENDER_LAYERS', update);
    window.addEventListener('resize', update);
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    mobilePreviewNoShrink();
  })
})()